/**
 * The watch signal, one place. The player reports where the playhead is; this
 * clamps it, hands it to the caller to remember on screen, and posts it to
 * `POST /watch/:token/progress`, which is what turns attended, completed, the
 * offer's arrival and the watch-depth automations on. The room and the Watch page
 * share it, so a talk watched in either counts exactly the same. A series'
 * replay names its session, so each session keeps its own place.
 */
import { useCallback, useRef } from "react";
import { api } from "../lib/api";

export function useWatchProgress(
  token: string,
  webinarId: string,
  remember: (watchedSec: number, watchedPct: number) => void,
  sessionId?: string,
): (sec: number, pct: number) => void {
  const latest = useRef(remember);
  latest.current = remember;
  return useCallback(
    (sec: number, pct: number) => {
      const watchedPct = Math.max(0, Math.min(100, Math.round(pct)));
      const watchedSec = Math.max(0, Math.round(sec));
      latest.current(watchedSec, watchedPct);
      api.watch
        .progress(token, {
          webinar_id: webinarId,
          ...(sessionId ? { session_id: sessionId } : {}),
          watched_sec: watchedSec,
          watched_pct: watchedPct,
        })
        .catch(() => {});
    },
    [token, webinarId, sessionId],
  );
}
